module.exports = __webpack_public_path__ + "static/media/secondary-key.d82887ff.svg";